import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ChatDataActions,
  selectActiveChatFiles,
  selectChatDataLoading,
  selectDataOrigin,
  selectTempFiles,
} from '@iese-chatbot/chat-data-access';
import { DataOrigin, FileUtils } from '@iese-chatbot/common-utils';
import { FilesUiComponent, NoneUiComponent, RepositoryUiComponent } from '@iese-chatbot/ui-design-system';
import { Store } from '@ngrx/store';
import { BdcWalkModule, BdcWalkService } from 'bdc-walkthrough';
import { BadgeModule } from 'primeng/badge';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { map } from 'rxjs';

@Component({
  selector: 'icbc-data-origin-selector',
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
    BadgeModule,
    BdcWalkModule,
    RepositoryUiComponent,
    NoneUiComponent,
    FilesUiComponent,
    SkeletonModule,
  ],
  templateUrl: './data-origin-selector.component.html',
})
export class DataOriginSelectorComponent {
  protected value: DataOrigin = DataOrigin.REPOSITORY;
  protected hasTempFiles = false;
  protected hasActiveChatFiles = false;
  protected loading = true;
  protected readonly DataOrigin = DataOrigin;

  constructor(private store: Store, protected bdcWalkService: BdcWalkService) {
    this.store
      .select(selectChatDataLoading)
      .pipe(takeUntilDestroyed())
      .subscribe((loading) => {
        this.loading = loading;
      });
    this.store
      .select(selectActiveChatFiles)
      .pipe(
        takeUntilDestroyed(),
        map((files) => files.length > 0),
      )
      .subscribe((hasFiles) => (this.hasActiveChatFiles = hasFiles));
    this.store
      .select(selectTempFiles)
      .pipe(
        takeUntilDestroyed(),
        map((files) => files.length > 0),
      )
      .subscribe((hasFiles) => (this.hasTempFiles = hasFiles));
    this.store
      .select(selectDataOrigin)
      .pipe(takeUntilDestroyed())
      .subscribe((dataOrigin) => {
        this.value = dataOrigin;
      });
  }

  // TODO refactor código duplicado
  endOnboardingTour() {
    this.bdcWalkService.setTaskCompleted('dialogStep1', true);
    this.bdcWalkService.setTaskCompleted('dialogStep2', true);
    this.bdcWalkService.setTaskCompleted('popupStep3', true);
    this.bdcWalkService.setTaskCompleted('popupStep4', true);
    this.bdcWalkService.setTaskCompleted('popupStep5', true);
    // this.bdcWalkService.setTaskCompleted('popupStep6', true);
    // this.bdcWalkService.setTaskCompleted('popupStep7', true);
    this.bdcWalkService.setTaskCompleted('dialogStep8', true);
    this.bdcWalkService.setTaskCompleted('popupStep9', true);
    this.bdcWalkService.setTaskCompleted('popupStepOwnFiles', true);
    this.bdcWalkService.setTaskCompleted('popupStepSelectOrigin', true);
    this.bdcWalkService.setTaskCompleted('popupStepCombineOrigin', true);
    // this.bdcWalkService.setTaskCompleted('popupStep10', true);
    this.bdcWalkService.setTaskCompleted('popupStep11', true);
    this.bdcWalkService.setTaskCompleted('dialogStep12', true);
    this.bdcWalkService.setTaskCompleted('dialogStep13', true);
  }

  protected select(value: DataOrigin) {
    if (value === this.value) return;
    if (value === DataOrigin.FILES && !this.hasActiveChatFiles) {
      FileUtils.forceOpenFileDialog();
    } else {
      this.store.dispatch(ChatDataActions.setDataOrigin({ dataOrigin: value }));
    }
  }
}
